<!-- A l'ouverture, la page n'affiche que la colonne avec la liste des séries de distributeurs -->
<h2>Séries de distributeurs</h2>
<div class="row">
    <div class="col-sm-3">
        <!-- hidden for now - 30/03/2022
            <button class="btn btn-outline-info btn-block" type="button"><i
                class="material-icons">add_circle_outline</i>Commencer une nouvelle série</button>
        <button class="btn btn-outline-info btn-block" type="button"><i
                class="material-icons">add_circle_outline</i>Ajouter de nouveaux distributeurs</button> -->
        <ng-container *ngIf="machinesSeries && machinesSeries.machines_series">
            <ng-container *ngFor="let serie of machinesSeries.machines_series">
                <button class="btn btn-outline-info btn-block" type="button"
                    (click)="getOneMachineSerieData(serie.id_machine_serie)">
                    {{ serie.nom_serie }} {{ serie.abbreviation }} ({{serie.count }} machine(s))</button>
            </ng-container>
        </ng-container>
    </div>


    <div class="col-sm-9" *ngIf="btnClicked">
        <ng-container *ngIf="machines">
            <div class="row series-section">
                <div>
                    <p>Nom de la série : {{ machines.serie.nom_serie }} </p>
                    <p>Abbréviation : {{ machines.serie.abbreviation }}</p>
                    <p>Descriptif : {{ machines.serie.descriptif }}</p>
                    <p>Date de début de fabrication : {{ machines.serie.date_debut }}</p>
                    <p>Date de fin de fabrication : {{ machines.serie.date_fin }}</p>
                    <button class="btn btn-outline-info">Modifier</button>
                </div>
            </div>

            <div class="row">
                <div *ngFor="let machine of machines.machines_serie">
                    <div class="series-dap">
                        <h4> Numero serie : {{ machine.numero_serie}} </h4>
                        <a [routerLink]="['/installation', machine.id_installation]"> {{ machine.nom_installation }}
                        </a>
                    </div>
                </div>
            </div>

        </ng-container>
    </div>

</div>